import { css } from '@emotion/css';

export const currentHashtagStyle = css({
  display: 'flex'
});
